import { render, staticRenderFns } from "./faceLogin.vue?vue&type=template&id=56f45359&"
import script from "./faceLogin.vue?vue&type=script&lang=js&"
export * from "./faceLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports